import { createSlice } from '@reduxjs/toolkit';
import tarotDeckData from '../../data/tarot-deck.json';

// El mazo es contenido estático empaquetado con la app (no se descarga en
// runtime), así que se carga sincrónicamente al iniciar el store — es la
// única fuente de verdad para las 78 cartas y sus imágenes locales
// (public/cards/), en vez de que cada componente importe el JSON por su cuenta.
const tarotSlice = createSlice({
  name: 'tarot',
  initialState: {
    cards: tarotDeckData.cards,
    spreads: tarotDeckData.spreads,
  },
  reducers: {},
});

export default tarotSlice.reducer;
